<template>
  <div class="input-model-box">
    <el-input
      placeholder="请输入盘点单批号"
      v-model="batchOrderNo"
      @blur="inventoryOrderChange"
      :disabled="column.disabled"
    >
      <template slot="append">
        <div class="el-icon-more more-btn" @click="showInventoryOrderList"></div>
      </template>
    </el-input>
    <el-dialog
      :title="column.label"
      :visible.sync="dialogVisible"
      @close="beforeClose"
      center
      :modal-append-to-body="false"
    >
      <purchase-list-template
        ref="listTable"
        @rowClick="inventoryOrderCheck"
        :tableOptions="tableOptions"
      ></purchase-list-template>
    </el-dialog>
  </div>
</template>
<script>
  import api from "@/config/api";
  import purchaseListTemplate from "@/components/template/purchaseListTemplate.vue";

  export default {
    components: {purchaseListTemplate},
    props: ["column", "defaultValue"],
    data() {
      return {
        batchOrderNo: "",
        checkList: [],
        dialogVisible: false,
        inventoryOrderList: null,
        tableOptions: {
          url: this.column.url,
          height: "100%",
          isRowClick: true,
          columns: this.column.columns
        },
        btnClick: false
      };
    },
    watch: {
      defaultValue() {
        this.batchOrderNo = this.defaultValue;
      }
    },
    methods: {
      initData() {
        this.batchOrderNo = "";
        this.checkList = {};
      },
      showInventoryOrderList() {
        if (this.column.disabled) return;
        if (this.column.params === undefined || this.column.params.warehouseId === undefined) {
          this.$message.warning("请选择仓库");
          return;
        }
        this.btnClick = true;
        this.dialogVisible = true;
        this.getInventoryOrderList();
      },
      inventoryOrderChange() {
        if (this.btnClick) return;
        if (this.column.params === undefined || this.column.params.warehouseId === undefined) {
          this.$message.warning("请选择仓库");
          return;
        }
        if (this.batchOrderNo === "" || this.batchOrderNo === null) return;
        this.dialogVisible = true;
        this.getInventoryOrderList();
      },
      getInventoryOrderList() {
        if (this.btnClick) this.batchOrderNo = "";
        this.inventoryOrderList = [];
        this.$nextTick(() => {
          this.$refs["listTable"].initData({
            warehouseId: this.column.params && this.column.params.warehouseId,
            orderNo: this.batchOrderNo,
          });
        });
      },
      inventoryOrderCheck(row) {
        this.checkList = row;
        this.batchOrderNo = row.orderNo;
        this.dialogVisible = false;
        this.$emit("valueChange", row, this.column);
      },
      beforeClose() {
        this.batchOrderNo = this.checkList.orderNo;
        this.btnClick = false;
      }
    }
  };
</script>



// WEBPACK FOOTER //
// src/components/business/inventoryOrderInputDialog.vue